// Global loading overlay utility — attaches `showLoading` / `hideLoading` to window
(function() {
  if (window.__globalLoadingInitialized) return;
  window.__globalLoadingInitialized = true;

  const css = `
  #global-loading-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.35); display: none; align-items: center; justify-content: center; z-index: 9999; }
  #global-loading-overlay .gl-panel { background: rgba(0,0,0,0.6); padding: 18px 22px; border-radius: 8px; display: flex; gap: 12px; align-items: center; color: #fff; font-weight: 600; box-shadow: 0 6px 18px rgba(0,0,0,0.35); }
  #global-loading-overlay .gl-spinner { width: 32px; height: 32px; border-radius: 50%; border: 4px solid rgba(255,255,255,0.15); border-top-color: #ffffff; animation: gl-spin 1s linear infinite; }
  @keyframes gl-spin { to { transform: rotate(360deg); } }
  #global-loading-overlay .gl-text { font-size: 14px; opacity: 0.95; }
  `;

  const s = document.createElement('style');
  s.setAttribute('type', 'text/css');
  s.appendChild(document.createTextNode(css));
  document.head && document.head.appendChild(s);

  const overlay = document.createElement('div');
  overlay.id = 'global-loading-overlay';
  overlay.innerHTML = '<div class="gl-panel"><div class="gl-spinner" aria-hidden="true"></div><div class="gl-text">Loading…</div></div>';
  document.body && document.body.appendChild(overlay);

  window.showLoading = function(text) {
    try {
      const ol = document.getElementById('global-loading-overlay');
      if (!ol) return;
      const txt = ol.querySelector('.gl-text');
      if (txt) txt.textContent = text || 'Loading…';
      ol.style.display = 'flex';
    } catch (e) { /* ignore */ }
  };

  window.hideLoading = function() {
    try {
      const ol = document.getElementById('global-loading-overlay');
      if (!ol) return;
      ol.style.display = 'none';
    } catch (e) { /* ignore */ }
  };
})();

export {};
